import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Footprints, Loader2, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useCrawl } from "@/context/CrawlContext";
import { VenueMap } from "@/components/VenueMap";
import { ShareButton } from "@/components/ShareButton";
import { StopList, routeMiles } from "@/pages/Crawl";
import { directionsUrl } from "@/lib/hh";

export default function SharedCrawl() {
  const { id } = useParams();
  const nav = useNavigate();
  const { setStops } = useCrawl();
  const [crawl, setCrawl] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    api.get(`/crawls/${id}`).then((r) => setCrawl(r.data)).catch((e) => setErr(errMsg(e)));
  }, [id]);
  if (err) return <div className="page"><p data-testid="crawl-error" className="panel p-6 text-zinc-300">{err}</p></div>;
  if (!crawl) return <div className="page flex justify-center py-20"><Loader2 className="animate-spin text-[#fde68a]" /></div>;
  const first = crawl.venues[0];
  return (
    <div className="page">
      <p className="eyebrow">Shared bar crawl</p>
      <h1 data-testid="shared-crawl-name" className="font-heading mt-2 text-5xl text-white sm:text-6xl">{crawl.name}</h1>
      <p className="mt-2 flex items-center gap-2 text-sm text-zinc-300">
        <Footprints size={16} className="text-[#fde68a]" /> {crawl.venues.length} stops · about {routeMiles(crawl.venues).toFixed(1)} mi walking
      </p>
      <div className="mt-5 flex flex-wrap gap-2">
        <ShareButton title={crawl.name} text={`Join my bar crawl: ${crawl.name}`} path={`/crawl/${crawl.id}`} testId="shared-crawl-share" />
        {first && <a href={directionsUrl(first)} target="_blank" rel="noopener noreferrer" data-testid="shared-crawl-start" className="rounded-full bg-[#fde68a] px-4 py-2 text-sm font-bold text-zinc-950">Directions to stop 1</a>}
        <button data-testid="shared-crawl-copy" onClick={() => { setStops(crawl.venues); toast.success("Copied to your crawl builder"); nav("/crawl"); }} className="chip"><Copy size={14} /> Edit a copy</button>
      </div>
      <div className="mt-8 grid gap-6 lg:grid-cols-5">
        <div className="lg:col-span-2"><StopList stops={crawl.venues} /></div>
        <div className="lg:col-span-3"><VenueMap venues={crawl.venues} route className="h-[60vh] min-h-[380px]" /></div>
      </div>
    </div>
  );
}
